import { useEffect } from "react";
import Lenis from "lenis";

let lenisSingleton = null;

export function useLenis() {
    useEffect(() => {
        if (lenisSingleton) return;
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1.0,
            touchMultiplier: 1.4,
        });
        lenisSingleton = lenis;

        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        return () => {
            try { lenis.destroy(); } catch (_) { /* noop */ }
            lenisSingleton = null;
        };
    }, []);
}

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisSingleton) {
        lenisSingleton.scrollTo(el, { offset: -60, duration: 1.2 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}
